export const throttle = (func) => {
    let context = null;
    let latestArgs = null;
    let animationFrame = null;
    const later = () => {
        animationFrame = null;
        func.apply(context, latestArgs);
    };
    return ((...args) => {
        context = this;
        latestArgs = args;
        if (!animationFrame) {
            animationFrame = window.requestAnimationFrame(later);
        }
    });
};
export const debounce = (func, timeout) => {
    let timeoutId;
    return ((...args) => {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(func, timeout, ...args);
    });
};



// WEBPACK FOOTER //
// ./node_modules/@ps/payscale-shared-ui/lib/TimingUtils/index.js